export default function () {
  const widgetName = 'merchStore';
  const widgetOpts = merchStoreOpts;
  const clientPath = SITEBASEURL;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    cardWidgetLoaded: function (data) {
      $(`#${widgetName}`).replaceWith(
        `<a href="${data.items[0].URL}" class="merch-store-btn" ${!data.items[0].URL.includes(clientPath) ? 'target="_blank"' : ''}>${data.items[0].Title}</a>`,
      );
    },

    scriptPath: widgetOpts.scriptPath,
  });
}
